module.exports = __webpack_public_path__ + "img/deel-de-zon.80ea94e8.svg";